import React, { useEffect, useState, } from 'react';
import { Link, } from 'react-router-dom';

import axios from 'axios';
import $ from 'jquery';
import Swal from 'sweetalert2';

import useAuth from '../../controllers/users/useAuth';
import InformativeBillboardAddEdit from './InformativeBillboardAddEdit';
import { informativeBillboardModelGet } from '../../models/informativeBillboard/informativeBillboard';

import {
    checkIfUserIsMaster, dataTableLanguaje, responseGet, globalSettings, styles, sendMessageCloseCurrentWindowAsync, dateTimeFormatGlobalSet, textByNumericStatus, iconsGet, statusGet, processEvaluateGet,
    languageObjGet, isUndNullEmp, LoadingSection,
} from '../../helpers/settings';
import Menu from '../main/Menu';
import { buildingsByUserGetAsync, userApartmentsGetAsync } from '../../controllers/apartments/apartmentUsers';
import BuildingHeader from '../buildings/BuildingHeader';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { buildingModelGet } from '../../models/buildings/building';
import { apartmentUserModelGet } from '../../models/apartments/apartmentUser';
import { userModelGet } from '../../models/users/user';

const currentMethod = 'InformativeBillboard';

const { app, icons, images, labels, messages, react: reactSett, } = globalSettings;
const { backend, } = app;

export default function InformativeBillboard({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const auth = useAuth();
    const [showModal, setShowModal] = useState(false);
    const [showLoading, setShowLoading] = useState({ building: true, informativeBillboard: true, });
    const [btnAddDisabled, setBtnAddDisabled] = useState(true);
    const userRole = checkIfUserIsMaster({ email: auth?.user?.email || '', languageId: languageObj?.id, subMethod: currentMethod, })?.result;
    const [processValue, setProcessValue] = useState({
        dtId: '',
        dtRowIndex: 0,
        icons: iconsGet({ languageId: languageObj?.id, subMethod: currentMethod, }),
        processType: 0,
        status: statusGet({ languageId: languageObj?.id, subMethod: currentMethod, }),
        titleTypes: textByNumericStatus({ languageId: languageObj?.id, subMethod: currentMethod, }),
        user: userModelGet({}),
        apartmentUsers: [apartmentUserModelGet({})],
        userRole: userRole,
    });
    //#endregion variables

    //#region informative billboard
    let informativeBillboards = [informativeBillboardModelGet({})];
    const dtInformativeBillboardId = 'dtInformativeBillboard';
    const [btnSyncCreateDisabled, setBtnSyncCreateDisabled] = useState(true);
    const [informativeBillboard, setInformativeBillboard] = useState(informativeBillboardModelGet({}));
    //#endregion informative billboard

    //#region buildings
    const selBuildingsId = 'selBuildings';
    const [buildings, setBuildings] = useState([buildingModelGet({})]);
    const [building, setBuilding] = useState(buildingModelGet({}));
    const [buildingId, setBuildingId] = useState('');
    //#endregion buildings

    //#region others
    const controls = {
        buttons: {
            // create: {
            //     className: 'btn btn-outline-success float-right btn-sm',
            //     id: 'btnCreate',
            // },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        dataTables: {
            informativeBillboard: {
                buttons: {
                    create: {
                        className: 'btn btn-outline-success float-right btn-sm',
                        id: 'btnDtCondominiumBoardElectionsCreate',
                    },
                    delete: {
                        className: 'btn btn-outline-danger float-right btn-sm mx-1',
                        id: 'btnDtCondominiumBoardElectionsDelete',
                    },
                },
                icons: {
                    create: {
                        id: 'iconDtCondominiumBoardElectionsCreate',
                        className: icons?.plusCircle,
                    },
                    delete: {
                        id: 'iconDtCondominiumBoardElectionsDelete',
                        className: icons?.trash,
                    },
                },
                inputs: {
                    search: {
                        id: `${dtInformativeBillboardId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtInformativeBillboardId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    create: {
                        id: 'spDtCondominiumBoardElectionsCreate',
                        className: '',
                    },
                    delete: {
                        id: 'spDtCondominiumBoardElectionsDelete',
                        className: '',
                    },
                },
            },
        },
        icons: {
            // create: {
            //     id: 'iconCreate',
            //     className: icons?.plusCircle,
            // },
        },
        inputs: {
            // email: {
            //     id: 'inputEmail',
            // },
            // password: {
            //     id: 'inputPassword',
            // },
        },
        spinners: {
            // create: {
            //     id: 'spCreate',
            //     className: '',
            // }
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region informative billboard (methods)
    const dataTableInformativeBillboardSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataTableInformativeBillboardSetAsync';
        let response = responseGet();
        try {
            $(`#${dtInformativeBillboardId}`)?.DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: '', width: '33%', orderable: false, },
                    { title: '', width: '33%', orderable: false, },
                    { title: '', width: '33%', orderable: false, },
                    //{ title: labels?.process?.[languageObj?.id], className: 'text-center', orderable: false, searchable: false, width: '5%', },
                ],
                data: [],
                destroy: true,
                drawCallback: function () {
                    $(`#${dtInformativeBillboardId} thead`).remove();
                },
                fixedColumns: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                //order: [[0, 'desc']],
                order: [],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                //}).buttons().container().appendTo(`#${dtPurchasesId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const informativeBillboardsGetAsync = async ({ e = {}, processType_ = '', subMethod = '', }) => {
        const currentMethod = 'informativeBillboardsGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let buildingIdLocal = '';
            let buildingLocal = buildingModelGet({});
            let informativeBillboardsLocal = [informativeBillboardModelGet({})];
            processType_ = processType_ === 's' || processType_ === 'b' ? '' : processType_;
            //#endregion variables

            setShowLoading({ building: false, informativeBillboard: true, });

            //#region initialize
            setBuilding({});
            informativeBillboards = [];
            setBtnSyncCreateDisabled(true);
            $(`#${dtInformativeBillboardId}`)?.DataTable()?.rows()?.clear()?.draw(true);
            //#endregion initialize

            //#region get informative billboard
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                //buildingIdLocal = e?.target?.value;
                buildingIdLocal = $(`#${selBuildingsId}`)?.val();
                setBuildingId(buildingIdLocal);
            } else {
                buildingIdLocal = !isUndNullEmp({ data: buildingId, subMethod: currentMethod, })?.result ? buildingId : processType_;
            }

            if (!isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                buildingLocal = buildings?.filter(({ id }) => id === buildingIdLocal)?.[0];
                setBuilding(buildingLocal);

                //#region  Get data
                response = await informativeBillboardWithDetailsByIdGetAsync({
                    id: '',
                    buildingId: buildingIdLocal,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    setShowLoading({ building: false, informativeBillboard: false, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }

                informativeBillboardsLocal = response.result;

                //#region old code
                // //#region check is enebled btnAdd
                // if (!isUndNullEmp({data:informativeBillboardsLocal, subMethod: currentMethod, })?.result && informativeBillboardsLocal?.length > 0) {
                //     //#region With details
                //     //#region old code
                //     // localIsEdit = processEvaluateGet(
                //     //     localInformativeBillboards[0],
                //     //     labels?.process?.en?.toLowerCase(),
                //     //     labels?.edit?.en?.toLowerCase(),
                //     //     localSubMethodName
                //     // ).result;

                //     // localIsDelete = processEvaluateGet(
                //     //     localInformativeBillboards[0],
                //     //     labels?.process?.en?.toLowerCase(),
                //     //     labels?.delete?.en?.toLowerCase(),
                //     //     localSubMethodName
                //     // ).result;
                //     //#endregion old code
                //     //#endregion With details
                // } else {
                //     //#region With out details
                //     //#region old code
                //     // localIsEdit = processEvaluateGet(
                //     //     localBuilding,
                //     //     labels?.process?.en?.toLowerCase(),
                //     //     labels?.edit?.en?.toLowerCase(),
                //     //     localSubMethodName
                //     // ).result;
                //     // localIsDelete = localIsEdit;
                //     //#endregion old code
                //     //#endregion With out details
                // }
                // //#endregion check is enebled btnAdd
                //#endregion old code
                //#endregion  Get data

                setBtnSyncCreateDisabled(false);
                //#region old code
                //setBtnAddDisabled(!(localIsEdit && localIsDelete));
                //#endregion old code
                setBtnAddDisabled(false);
            }
            //#endregion get informative billboard

            //#region dataTable set / Add purchases dtTable (purchases)
            //#region old code
            // response = dataTablesSetAsync(true);
            // if (!response?.isSuccess || response?.isWarning) {
            //     setShowLoading(false);
            //     //setShowData(false);
            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //     return;
            // }
            //#endregion old code

            response = await dataTableLoadDataAsync({
                informativeBillboards: informativeBillboardsLocal,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading(false);
                return response;
            }

            informativeBillboards = response.result;
            $(`#${dtInformativeBillboardId}`)?.DataTable()?.rows?.add(informativeBillboards)?.draw(true);
            //#endregion dataTable set / Add purchases dtTable (purchases)

            setShowLoading({ building: false, informativeBillboard: false, });
        } catch (ex) {
            setShowLoading({ building: false, informativeBillboard: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const informativeBillboardAddEditDetailsDeleteGetAsync = async ({ e = {}, id = '', description = '', rowIndex = 0, processType = 0, subMethod = '', }) => {
        const currentMethod = 'informativeBillboardAddEditDetailsDeleteGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let userLocal = userModelGet({});
            let showModalLocal = false;
            let apartmentUsersLocal = [apartmentUserModelGet({})];
            const buildingIdLocal = $(`#${selBuildingsId}`)?.val();
            //#region response is warning
            let responseIsWarning = responseGet();
            responseIsWarning.msgType = 1;
            responseIsWarning.isWarning = true;
            responseIsWarning.msgText = `Method: ${subMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
                responseIsWarning.msgText += `Sub method: ${subMethod}<br/>`;
            }
            //#endregion response is warning
            //#endregion variables

            //#region set initialize
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }
            //#endregion set initialize

            //#region building validate
            if (processType === 0) {
                if (isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: 1,
                        msgText: messages?.youMustSelectBuilding?.[languageObj?.id],
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
            }
            //#endregion building validate

            if (processType === 0) {
                controlsStatusSet({ processType: 1, subMethod: currentMethod, });
            } else if (processType === 1 || processType === 2) {
                setShowLoading({ building: false, informativeBillboard: true, });
            }

            //#region user get
            if (processType !== -1) {
                response = await userByIdGetAsync({
                    id: auth?.user?.uid,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: 1,
                        msgText: messages?.youMustSelectBuilding?.[languageObj?.id],
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }

                userLocal = response?.result;
            }
            //#endregion get user

            //#region user get apartments
            if (processType !== -1) {
                response = await userApartmentsGetAsync({
                    buildingId: buildingIdLocal,
                    auth: auth,
                    userRole: userRole,
                    method: backend?.methods?.apartmentUsersWithDetails,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    if (processType === 0) {
                        controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                    } else if (processType === 1 || processType === 2) {
                        setShowLoading({ building: false, informativeBillboard: false, });
                    }
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }

                apartmentUsersLocal = response?.result?.apartmentUsers;

                if (!isUndNullEmp({ data: apartmentUsersLocal, subMethod: currentMethod, })?.result && apartmentUsersLocal?.length <= 0) {
                    if (processType === 0) {
                        controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                    } else if (processType === 1 || processType === 2) {
                        setShowLoading({ building: false, informativeBillboard: false, });
                    }
                    responseIsWarning.msgText = `${messages?.youMustCreateLeastOneApartment?.[languageObj?.id]}<br/>`;
                    responseIsWarning.msgText += `${messages?.goTo?.[languageObj?.id]}: <i class='${icons?.houseUser}'></i> `;
                    responseIsWarning.msgText += `<a href='${backend?.urlApartments}'>${labels?.apartments?.[languageObj?.id]}</a>`;
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: responseIsWarning?.msgType,
                        msgText: !isUndNullEmp({ data: responseIsWarning?.msgHtml, subMethod: currentMethod, })?.result ? responseIsWarning?.msgHtml : responseIsWarning?.msgText,
                        closeWindow: false,
                        urlGoTo: responseIsWarning?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
            }
            //#endregion get user apartments

            //#region set initial data
            const key = globalSettings?.collections?.properties?.descriptionTwo;
            setProcessValue({
                ...processValue,
                dtId: dtInformativeBillboardId,
                dtRowIndex: rowIndex,
                //icons: orderBy(processValue.icons, 'descriptionTwo', 'asc'),
                //icons: processValue?.icons?.sort((a, b) => a?.descriptionTwo?.toLowerCase()?.localeCompare(b?.descriptionTwo?.toLowerCase())),
                icons: processValue?.icons?.sort((a, b) => a?.[key]?.toLowerCase() > b?.[key]?.toLowerCase() ? 1 : -1),
                processType: processType,
                user: userLocal,
                apartmentUsers: apartmentUsersLocal,
                userRole: userRole,
            });
            //#endregion set initial data

            //#region get Informative billboard
            if (processType > 0) {
                response = await informativeBillboardWithDetailsByIdGetAsync({
                    id: id,
                    buildingId: buildingIdLocal,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    setShowLoading({ building: false, informativeBillboard: false, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }

                setInformativeBillboard(response?.result?.[0]);
            }
            //#endregion get Informative billboard

            //#region get informative billboard
            if (processType === -1) {
                //#region old code
                // response = await localInformativeBillboardDeleteAsync(id, buildingIdLocal, description, rowIndex);
                // if (!response?.isSuccess || response?.isWarning) {
                //     await sendMessageCloseCurrentWindowAsync({
                //         msgType: response?.msgType,
                //         msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                //         closeWindow: false,
                //         urlGoTo: response?.urlGoTo,
                //         auth: auth,
                //         isLogout: false,
                //         languageId: languageObj?.id,
                //         subMethod: currentMethod,
                //     });
                //     return;
                // }
                //#endregion old code

                //#region show message
                let msgTextObj = {
                    one: `${labels?.title?.[languageObj?.id]}: <b>${description}</b><br/>`,
                    //two: `${description}<br/>`,
                    two: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
                };

                let swalProperties = {
                    icon: reactSett?.sweetAlert2?.icons?.warning,
                    title: messages?.areYouSureDeleteThis?.[languageObj?.id],
                    html: `${msgTextObj?.one}${msgTextObj?.two}`,
                    timer: null,
                    backdrop: true,
                    confirmButtonColor: globalSettings?.colors?.warningColorExp,
                    confirmButtonText: labels?.yes?.[languageObj?.id],
                    showCancelButton: true, //!Swal.isLoading(), //true,
                    cancelButtonColor: globalSettings?.colors?.successColorExp,
                    cancelButtonText: labels?.no?.[languageObj?.id],
                    showLoaderOnConfirm: true,
                    didOpen: () => {
                        Swal.hideLoading();
                    },
                    preConfirm: async () => {
                        try {
                            Swal.getCancelButton().hidden = true;
                            Swal?.update({
                                icon: reactSett?.sweetAlert2?.icons?.info,
                                title: `${messages?.processing?.[languageObj?.id]}...`,
                                html: `${msgTextObj?.one}`,
                                showConfirmButton: false,
                            });

                            //#region delete condominium board election
                            headerObj = {
                                headers: {
                                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                                    languageId: languageObj?.id,
                                },
                                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlInformativeBillboards}/${id}`,
                            };

                            result = await axios.delete(
                                headerObj?.url,
                                headerObj,
                            );

                            response = result?.data;

                            if (!response?.isSuccess || response?.isWarning) {
                                await sendMessageCloseCurrentWindowAsync({
                                    msgType: response?.msgType,
                                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                    closeWindow: false,
                                    urlGoTo: response?.urlGoTo,
                                    auth: auth,
                                    isLogout: false,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                });
                                return;
                            }
                            //#endregion delete condominium board election

                            //#region delete condominium board election (dataTable)
                            setShowLoading({ building: false, informativeBillboard: true, });

                            response = await informativeBillboardsGetAsync({
                                e: undefined,
                                processType_: buildingIdLocal,
                                subMethod: currentMethod,
                            });

                            if (!response?.isSuccess || response?.isWarning) {
                                setShowLoading({ building: false, informativeBillboard: false, });
                                await sendMessageCloseCurrentWindowAsync({
                                    msgType: response?.msgType,
                                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                    closeWindow: false,
                                    urlGoTo: response?.urlGoTo,
                                    auth: auth,
                                    isLogout: false,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                });
                                return;
                            }

                            setShowLoading({ building: false, informativeBillboard: false, });
                            //#endregion delete condominium board election (dataTable)

                            await sendMessageCloseCurrentWindowAsync({
                                msgType: 0,
                                msgText: `${messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                        } catch (ex) {
                            setShowLoading({ building: false, informativeBillboard: false, });
                            //#region Error
                            response.isSuccess = false;
                            response.msgType = -1;
                            response.msgText = `Method: ${currentMethod}<br/>`;
                            response.msgText += `Error: ${ex?.message}`;
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                            });
                            //#endregion Error
                        }
                    },
                    allowOutsideClick: () => !Swal.isLoading(),
                };

                await Swal.fire(swalProperties);
                //#endregion show message
            } else if (processType === 0) {
                setInformativeBillboard(
                    informativeBillboardModelGet({
                        buildingId: buildingIdLocal,
                        apartmentId: '',
                        userId: auth?.user?.uid,
                    })
                );
                showModalLocal = true;
            } else {
                showModalLocal = true;
            }
            //#endregion get informative billboard

            if (processType === 0) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            } else if (processType === 1 || processType === 2) {
                setShowLoading({ building: false, informativeBillboard: false, });
            }

            setShowModal(showModalLocal);
        } catch (ex) {
            if (processType <= 0) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            } else if (processType === 1 || processType === 2) {
                setShowLoading({ building: false, informativeBillboard: false, });
            }
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataTableLoadDataAsync = async ({ informativeBillboards = [], subMethod = '', }) => {
        const currentMethod = 'dataTableLoadDataAsync';
        let response = responseGet();
        try {
            //#region variables
            let flagLocal = 0;
            let colsObj = {
                c001: '',
                c002: '',
                c003: '',
            };
            //let colsObj.c001 = ``;
            //let colsObj.c002 = ``;
            //let colsObj.c003 = ``;
            let dateTimeStr = '';
            let commentLocal = '';
            let msgTextLocal = ``;
            let ribbonColorLocal = '';
            let ribbonMsgTextLocal = '';
            let isEditLocal = false;
            let isDeleteLocal = false;
            const commentMaxLength = 42;
            //#endregion variables

            //#region process
            response.result = [];

            if (!isUndNullEmp({ data: informativeBillboards, subMethod: currentMethod, })?.result && informativeBillboards?.length > 0) {
                flagLocal = 0;
                colsObj.c001 = ``;
                colsObj.c002 = ``;
                colsObj.c003 = ``;
                dateTimeStr = '';
                informativeBillboards?.forEach((detail, index) => {
                    dateTimeStr = dateTimeFormatGlobalSet({
                        date: detail?.created || new Date(),
                        type: languageObj?.format?.date?.f1,
                        format: 12,
                        addTime: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result;
                    commentLocal = detail?.comment?.length > commentMaxLength ? `${detail?.comment?.substr(0, commentMaxLength)}...` : detail?.comment;
                    //#region check is enebled btnAdd
                    isEditLocal = processEvaluateGet({
                        object: detail,
                        property: labels?.process?.en?.toLowerCase(),
                        process: labels?.edit?.en?.toLowerCase(),
                        subMethod: currentMethod
                    })?.result;

                    isDeleteLocal = processEvaluateGet({
                        object: detail,
                        property: labels?.process?.en?.toLowerCase(),
                        process: labels?.delete?.en?.toLowerCase(),
                        subMethod: currentMethod
                    })?.result;
                    //#endregion check is enebled btnAdd

                    msgTextLocal = ``;
                    msgTextLocal = `<div class='position-relative b-0 bg-default' height='60px'>`;
                    msgTextLocal += `   <div class='ribbon-wrapper'>`;

                    //#region old code
                    // localMsgText += `       <div class='ribbon bg-primary'>`;
                    // localMsgText += `           Ribbon`;
                    // localMsgText += `       </div>`;
                    //#endregion old code

                    //#region set color / text ribbon
                    switch (detail?.status) {
                        case 1:
                            ribbonColorLocal = 'bg-success';
                            ribbonMsgTextLocal = labels?.approved?.[languageObj?.id];
                            break
                        case 2:
                            ribbonColorLocal = 'bg-warning';
                            ribbonMsgTextLocal = labels?.modify?.[languageObj?.id];
                            break
                        case 3:
                            ribbonColorLocal = 'bg-secondary';
                            ribbonMsgTextLocal = labels?.notApproved?.[languageObj?.id];
                            break
                        default:
                            ribbonColorLocal = 'bg-primary';
                            ribbonMsgTextLocal = labels?.created?.[languageObj?.id];
                            break;
                    }
                    //#endregion set color / text ribbon

                    msgTextLocal += `       <div class='ribbon ${ribbonColorLocal}'>`;
                    msgTextLocal += `           <div style='font-size:11px;text-transform:capitalize;'>`;
                    msgTextLocal += `               ${ribbonMsgTextLocal}`;
                    msgTextLocal += `           </div>`;
                    msgTextLocal += `       </div>`;

                    msgTextLocal += `   </div>`;
                    msgTextLocal += `   <div class='d-flex align-items-stretch flex-column'>`;
                    //msgTextLocal += `       <div class='d-flex align-items-stretch flex-column'>`;
                    msgTextLocal += `           <div class='card bg-light d-flex flex-fill'>`;
                    msgTextLocal += `               <div class='card-header text-muted border-bottom-0'>`;
                    //msgTextLocal += `                   <img src='../../dist/img/user2-160x160.jpg' alt='user-avatar' class='img-circle img-fluid' height='30px' width='30px'/>`;
                    msgTextLocal += `                   <img src='${detail?.iconPath}' alt='${detail?.iconName}' class='img-circle img-fluid' height='30px' width='30px'/>`;
                    msgTextLocal += `                   <span class='${processValue?.titleTypes?.filter(({ id, }) => id === `${detail?.type}`)?.[0]?.type}'>${detail?.title}</span>`;
                    msgTextLocal += `               </div>`;
                    msgTextLocal += `               <div class='card-body pt-0'>`;
                    msgTextLocal += `                   <div class='row'>`;
                    msgTextLocal += `                       <div class='col-12'>`;
                    msgTextLocal += `                           <ul class='ml-4 mb-0 fa-ul text-muted'>`;
                    msgTextLocal += `                               <li class='small'><span class='fa-li'><i class='${icons?.user}'></i></span> ${labels?.user?.[languageObj?.id]}: <b>${detail?.user?.firstName}, ${detail?.user?.lastName}</b></li>`;
                    msgTextLocal += `                               <li class='small'><span class='fa-li'><i class='${icons?.houseUser}'></i></span> ${labels?.apartment?.[languageObj?.id]}: <b>${detail?.apartment?.identifier}</b></li>`;
                    //msgTextLocal += `                               <li class='small'><span class='fa-li'><i class='${icons?.calendarAlt}'></i></span> ${labels?.created?.[languageObj?.id]}: <b>${dateTimeFormatGlobalSet(!isUndefined(detail?.created) && !isNull(detail?.created) ? detail?.created : new Date(), reactSett?.tempusDominus?.format?.date?.dmy, 12).result}</b></li>`;
                    msgTextLocal += `                               <li class='small'><span class='fa-li'><i class='${icons?.calendarAlt}'></i></span> ${labels?.created?.[languageObj?.id]}: <b>${dateTimeStr}</b></li>`;
                    msgTextLocal += `                               <li class='small'><span class='fa-li'><i class='${icons?.bullhorn}'></i></span> ${labels?.comment?.[languageObj?.id]}: <b>${commentLocal}</b></li>`;
                    msgTextLocal += `                           </ul>`;
                    // //msgTextLocal += `                          <br/>`;
                    // //msgTextLocal += `                           <p class='text-muted text-sm pt-2'><i class='${icons?.bullhorn}'></i> <b>${labels?.comment?.[languageObj?.id]}:</b> <br/>${detail?.comment.length > commentMaxLength ? `${detail?.comment.substr(0, commentMaxLength)}...` : detail?.comment}</p>`;
                    // msgTextLocal += `                           <p class='text-muted text-sm pt-2'>${detail?.comment.length > commentMaxLength ? `${detail?.comment?.substr(0, commentMaxLength)}...` : detail?.comment}</p>`;
                    msgTextLocal += `                       </div>`;
                    msgTextLocal += `                   </div>`;
                    msgTextLocal += `               </div>`;
                    msgTextLocal += `               <div class='card-footer'>`;
                    msgTextLocal += `                   <div class='text-right'>`;
                    msgTextLocal += `                       <button id='${detail?.id}' description='${detail?.title}' method='details' class='btn btn-outline-info btn-sm' title='${labels?.see?.[languageObj?.id]}'>`;
                    msgTextLocal += `                           <i id='${detail?.id}' description='${detail?.title}' method='details' class='${icons?.eyeIpasswordIpassword}'></i>`;
                    msgTextLocal += `                       </button>`;
                    if (isEditLocal && isDeleteLocal) {
                        msgTextLocal += `                       <button id='${detail?.id}' description='${detail?.title}' method='edit' class='btn btn-outline-warning btn-sm'>`;
                        msgTextLocal += `                           <i id='${detail?.id}' description='${detail?.title}' method='edit' class='${icons?.edit}' title='${labels?.edit?.[languageObj?.id]}'></i>`;
                        msgTextLocal += `                       </button>`;
                        msgTextLocal += `                       <button id='${detail?.id}' description='${detail?.title}' method='delete' class='btn btn-outline-danger btn-sm'>`;
                        msgTextLocal += `                           <i id='${detail?.id}' description='${detail?.title}' method='delete' class='${icons?.trash}' title='${labels?.delete?.[languageObj?.id]}'></i>`;
                        msgTextLocal += `                       </button>`;
                    }
                    msgTextLocal += `                   </div>`;
                    msgTextLocal += `               </div>`;
                    msgTextLocal += `           </div>`;
                    //msgTextLocal += `       </div>`;
                    msgTextLocal += `   </div>`;
                    msgTextLocal += `</div>`;

                    if (((index + 1) <= informativeBillboards.length && flagLocal !== 3) || ((index + 1) === informativeBillboards.length)) {
                        switch (flagLocal) {
                            case 0:
                                colsObj.c001 = msgTextLocal;
                                break;
                            case 1:
                                colsObj.c002 = msgTextLocal;
                                break;
                            default:
                                colsObj.c003 = msgTextLocal;
                                break;
                        }
                        flagLocal++;
                    }

                    if ((flagLocal === 3 && (index + 1) !== informativeBillboards.length) || ((index + 1) === informativeBillboards.length)) {
                        response.result.push([
                            colsObj.c001,
                            colsObj.c002,
                            colsObj.c003,
                        ]);
                        flagLocal = 0;
                        colsObj.c001 = ``;
                        colsObj.c002 = ``;
                        colsObj.c003 = ``;
                    }
                });
            }
            //#endregion process
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const informativeBillboardWithDetailsByIdGetAsync = async ({ id = '', buildingId = '', subMethod = '', }) => {
        const currentMethod = 'informativeBillboardWithDetailsByIdGetAsync';
        let response = responseGet();
        try {
            //#region  Get data
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                conditionals: [
                    { field: globalSettings?.collections?.properties?.buildingId, operator: reactSett?.firebase?.operators?.equalTo, value: `${buildingId}` },
                ],
                ordersBy: [
                    { field: globalSettings?.collections?.properties?.created, value: 'desc' },
                ],
                withDetails: true,
                id: id,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlInformativeBillboards}/`
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion  Get data
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    //#region old code
    // const localInformativeBillboardDeleteAsync = async (id = '', buildingId = '', description = '', rowIndex = 0) => {
    //     let response = responseGet();
    //     try {
    //         //#region show message

    //         let msgText = `${labels?.title?.[languageObj?.id]}:<br/>`;
    //         msgText += `<b>${description}</b><br/>`;
    //         msgText += `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`;

    //         const swalProperties = {
    //             icon: reactSett?.sweetAlert2?.icons?.warning,
    //             title: messages?.areYouSureDeleteThis?.[languageObj?.id],
    //             html: msgText,
    //             timer: null,
    //             confirmButtonColor: globalSettings?.colors?.warningColorExp,
    //             confirmButtonText: labels?.yes?.[languageObj?.id],
    //             showCancelButton: true,
    //             cancelButtonColor: globalSettings?.colors?.successColorExp,
    //             cancelButtonText: labels?.no?.[languageObj?.id],
    //             timerProgressBar: false,
    //             didOpen: () => {
    //                 Swal.hideLoading();
    //             },
    //         };

    //         const { isConfirmed, } = await Swal.fire(swalProperties);

    //         //#endregion show message

    //         //#region delete data

    //         if (isConfirmed) {
    //             sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

    //             //#region delete purchase

    //             headerObj = {
    //                 headers: {
    //                     authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
    //                 },
    //             };

    //             //result = await axios.delete(`${backend?.urlDev}${backend?.urlApiV1}${backend?.urlInformativeBillboards}/${id}`, headerObj);
    //             result = await axios.delete(`${backend?.url}${backend?.urlApiV1}${backend?.urlInformativeBillboards}/${id}`, headerObj);
    //             response = result.data;

    //             if (!response?.isSuccess || response?.isWarning) {
    //                 return response;
    //             }

    //             //#endregion delete purchase

    //             //#region delete purchase (dataTable)

    //             response = await informativeBillboardsGetAsync(null, buildingId);
    //             if (!response?.isSuccess || response?.isWarning) {
    //                 return response;
    //             }

    //             await sendMessageCloseCurrentWindowAsync(0, messages?.processesCompletedSuccessfully?.[languageObj?.id], false, response.urlGoTo, auth, false);

    //             //#endregion delete purchase (dataTable)
    //         }
    //         //#endregion delete data
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: localInformativeBillboardDeleteAsync<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //         response.result = { id, buildingId, description, rowIndex, };
    //     }
    //     return response;
    // }
    //#endregion old code
    //#endregion informative billboard (methods)

    //#region user
    const userByIdGetAsync = async ({ id = '', subMethod = '', }) => {
        const currentMethod = 'userByIdGetAsync';
        let response = responseGet();
        try {
            //#region user get
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    languageId: languageObj?.id,
                },
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlUsers}/${id}`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion get user
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }
    //#endregion user

    //#region apartments
    //#region old code
    // const localUserApartmentsGetAsync = async (buildingId = '') => {
    //     let response = responseGet();
    //     try {
    //         headerObj = {
    //             headers: {
    //                 authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
    //             },
    //         };

    //         localData = {
    //             conditionals: [],
    //             ordersBy: [],
    //             buildingId: buildingId,
    //             method: 'apartmentUserWithDetailsGetAsync',
    //             // Stay here
    //             // Do for all users
    //             userId: userRole === globalSettings?.roles?.master ? '' : auth?.user?.uid,
    //             withDetails: true,
    //         }
    //         //result = await axios?.post(`${backend?.urlDev}${backend?.urlApiV1}${backend?.urlApartmentUsers}/`, localData, headerObj);
    //         result = await axios?.post(`${backend?.url}${backend?.urlApiV1}${backend?.urlApartmentUsers}/`, localData, headerObj);
    //         response = result.data;

    //         if (!response?.isSuccess || response?.isWarning) {
    //             return response;
    //         }
    //     } catch (ex) {
    //         response.isSuccess = false;
    //         response.msgType = -1;
    //         response.msgText = `Method: localUserApartmentsGetAsync<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //     }
    //     return response;
    // }
    //#endregion old code
    //#endregion apartments

    //#region methods (others)
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //#region inicialize
            informativeBillboards = [];
            //#endregion inicialize

            setShowLoading({ building: true, informativeBillboard: true, });
            //setShowData(false);

            //#region dataTable set
            response = await dataTablesSetAsync({
                queryCodeSet: true,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, informativeBillboard: false, });
                //setShowData(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion dataTable set

            //#region buildings get
            response = await buildingsByUserGetAsync({
                userRole: userRole,
                auth: auth,
                urlGoTo: backend?.urlInformativeBillboards,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, informativeBillboard: false, });
                //setShowData(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            if (!isUndNullEmp({ data: response?.result?.buildings, subMethod: currentMethod, })?.result && response?.result?.buildings?.length > 0) {
                setBuildings(response?.result?.buildings);
            }
            //#endregion buildings get

            //#region dataTable set
            // response = await dataTablesSetAsync({ queryCodeSet: true, subMethod: currentMethod, });

            // if (!response?.isSuccess || response?.isWarning) {
            //     setShowLoading(false);
            //     //setShowData(false);
            //     await sendMessageCloseCurrentWindowAsync({
            //         msgType: response?.msgType,
            //         msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
            //         closeWindow: false,
            //         urlGoTo: response?.urlGoTo,
            //         auth: auth,
            //         isLogout: false,
            //         languageId: languageObj?.id,
            //         subMethod: currentMethod,
            //     });
            //     return;
            // }

            // response = localDataTableClears(true);
            // if (!response?.isSuccess || response?.isWarning) {
            //     setShowLoading(false);
            //     //setShowData(false);
            //     await sendMessageCloseCurrentWindowAsync({
            //         msgType: response?.msgType,
            //         msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
            //         closeWindow: false,
            //         urlGoTo: response?.urlGoTo,
            //         auth: auth,
            //         isLogout: false,
            //         languageId: languageObj?.id,
            //         subMethod: currentMethod,
            //     });
            //     return;
            // }

            //#endregion dataTable set

            setShowLoading({ building: false, informativeBillboard: false, });
            //setShowData(true);
        } catch (ex) {
            setShowLoading({ building: false, informativeBillboard: false, });
            //setShowData(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataTablesSetAsync = async ({ queryCodeSet = false, subMethod = '', }) => {
        const currentMethod = 'dataTablesSetAsync';
        let response = responseGet();
        try {
            response = await dataTableInformativeBillboardSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            if (queryCodeSet) {
                response = await queryCodeSetAsync({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const queryCodeSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'queryCodeSetAsync';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let method = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let description = '';
            //#endregion variables

            //#region informative billboard
            $(`#${dtInformativeBillboardId} tbody`)?.on('click', 'tr', 'td', function (e) {
                e.preventDefault();
                rowIndex = $(`#${dtInformativeBillboardId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    method = e?.target?.attributes?.method?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'details':
                            informativeBillboardAddEditDetailsDeleteGetAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType: 2, subMethod: currentMethod, });
                            break;
                        case 'edit':
                            informativeBillboardAddEditDetailsDeleteGetAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType: 1, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            informativeBillboardAddEditDetailsDeleteGetAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType: -1, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion informative billboard
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    //#region old code
    // const localDataTableClears = (purchasesClear = false) => {
    //     let response = responseGet();
    //     try {
    //         if (purchasesClear) {
    //             $(`#${dtInformativeBillboardId}`)?.DataTable()?.rows()?.clear()?.draw(true);
    //         }
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: localDataTableClears<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //     }
    //     return response;
    // }
    //#endregion old code

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.dataTables?.informativeBillboard?.icons?.create?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.informativeBillboard?.buttons?.create?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.informativeBillboard?.spinners?.create?.id}`)?.removeClass();

                    $(`#${controls?.dataTables?.informativeBillboard?.icons?.create?.id}`)?.addClass(controls?.dataTables?.informativeBillboard?.icons?.create.className);
                    $(`#${controls?.dataTables?.informativeBillboard?.buttons?.create?.id}`)?.addClass(controls?.dataTables?.informativeBillboard?.buttons?.create?.className);
                    $(`#${controls?.dataTables?.informativeBillboard?.spinners?.create?.id}`)?.addClass(controls?.dataTables?.informativeBillboard?.spinners?.create.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.create?.id}`)?.addClass(`${reactSett?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.dataTables?.informativeBillboard?.icons?.create?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.informativeBillboard?.spinners?.create?.id}`)?.addClass(`${reactSett?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region old code
            // $(`#${controls?.inputs?.email?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.inputs?.password?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.checkBox?.remenberMe?.id}`).attr('disabled', (processType !== 0));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : reactSett?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            $(`#${controls?.dataTables?.informativeBillboard?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.informativeBillboard?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            if (processType !== 0) {
                $(`#${controls?.dataTables?.informativeBillboard?.buttons?.create?.id}`)?.addClass(`${reactSett?.html?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', })
    }, []) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu viewName='condominiumBoard' process='informativeBillboard' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{labels?.informativeBillboard?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{labels?.informativeBillboard?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        {/*buildings*/}
                        <BuildingHeader buildingsId={selBuildingsId}
                            building={building}
                            buildings={buildings}
                            btnSyncDisabled={btnSyncCreateDisabled}
                            methodGetAsync={informativeBillboardsGetAsync}
                            processType={0}
                            headerSectionValues={{}}
                            showLoading={showLoading?.building}
                            languageObj={languageObj} />

                        {/*Informative billboard*/}
                        <div className='row'>
                            <div className='col-12'>
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={reactSett?.html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.informativeBillboard}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    {/*header*/}
                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.informativeBillboard?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={images?.informativeBillboard}></img> - {labels?.informativeBillboard?.[languageObj?.id]}
                                        </h6>
                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                        </div>
                                    </div> {/*card header*/}

                                    {/*body*/}
                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-md-12'>
                                                {/* {!showLoading ? */}
                                                {/* <div> */}
                                                {/* {showData ? */}
                                                {/* <div> */}
                                                <button id={controls?.dataTables?.informativeBillboard?.buttons?.create?.id}
                                                    className={controls?.dataTables?.informativeBillboard?.buttons?.create?.className}
                                                    tooltip='tooltip'
                                                    title={labels?.create?.[languageObj?.id]}
                                                    disabled={btnAddDisabled}
                                                    onClick={(e) => informativeBillboardAddEditDetailsDeleteGetAsync({ e: e, id: '', description: '', rowIndex: 0, processType: 0, subMethod: '', })}>
                                                    <i id={controls?.dataTables?.informativeBillboard?.icons?.create?.id} className={controls?.dataTables?.informativeBillboard?.icons?.create?.className} /> <span id={controls?.dataTables?.informativeBillboard?.spinners?.create?.id} className='' aria-hidden='true'></span>
                                                </button>

                                                <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                    {/* <table id={dtPurchasesId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table> */}
                                                    {/* <table id={dtInformativeBillboardId} className='table table-sm table-bordered'></table> */}
                                                    <table id={dtInformativeBillboardId} className={globalSettings?.html?.dataTables?.formats?.smBordered}></table>
                                                </div>
                                                {/* </div> */}
                                                {/* : */}
                                                {/* <div></div> */}
                                                {/* } */}
                                                {/* </div> */}
                                                {/* : */}
                                                {/* <CssfxLoading type={reactSett?.CssfxLoading?.circularProgress}
                                                        width={40}
                                                        height={40}
                                                        color={globalSettings?.colors?.infoColorExp}
                                                        msgText={messages?.processing?.[languageObj?.id]}
                                                        msgOrientation='text-center'
                                                        msgTextMuted={true} /> */}
                                                {/* } */}
                                            </div>
                                        </div>
                                    </div>

                                    {/*footer*/}
                                    <div className='card-footer'></div>
                                </div>
                            </div>
                        </div>

                    </div>{/* /.container-fluid*/}
                </section>{/* /.content*/}

            </div>{/* /.content-wrapper*/}

            {showModal ?
                <InformativeBillboardAddEdit $={$}
                    auth={auth}
                    processValue={processValue}
                    building={building}
                    informativeBillboard={informativeBillboard}
                    setInformativeBillboard={setInformativeBillboard}
                    showModal={showModal}
                    setShowModal={setShowModal}
                    informativeBillboardsGetAsync={informativeBillboardsGetAsync}
                    languageObj={languageObj} />
                :
                <></>
            }
        </div>
    )
}